import type { DetailedHTMLProps, FunctionComponent, LabelHTMLAttributes, ReactNode } from 'react'
import { Icon, IconName } from './Icon'
import styles from './InputLabel.module.sass'

export type InputLabelProps = Pick<
	DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>,
	'id' | 'children'
> & {
	isLabel?: boolean
	text?: ReactNode
	icon?: IconName
	isRequired?: boolean
}

export const InputLabel: FunctionComponent<InputLabelProps> = ({
	isLabel,
	children,
	isRequired,
	text,
	icon,
}) => {
	if (isLabel) {
		return (
			<label className={styles.label}>
				{text && (
					<span className={styles.labelContent}>
						{icon && (
							<span className={styles.labelIcon}>
								<Icon name={icon} />
							</span>
						)}
						<span className={styles.labelName}>
							{text}
							{isRequired && '*'}
						</span>
					</span>
				)}
				{children}
			</label>
		)
	}

	return <>{children}</>
}
